{
  "name": "@graphorin/agent",
  "version": "0.15.1",
  "description": "Agent runtime for the Graphorin framework: createAgent({...}) factory, the typed model -> tool calls -> model loop, the AgentEvent<TOutput> discriminated event stream, steering / followUp queues, durable HITL approvals via runStateToJSON / runStateFromJSON, multi-agent handoffs (Agent.toTool, filter library, secrets isolation), agent-level model fallback chain, intra-loop reasoning preservation, post-compaction hook lifecycle, agent-step-level fan-out (Agent.fanOut + evaluatorOptimizer + progress artifacts), per-tool model-tier hint resolution, lateral-leak defense layer (CausalityMonitor + MergeAgentSidewaysInjectionGuard + protocol-guard), inbound-content sanitization preamble injection, and AbortSignal-aware hard-kill / drain cancellation. Created and maintained by Oleksiy Stepurenko.",
  "license": "MIT",
  "author": "Oleksiy Stepurenko",
  "homepage": "https://github.com/o-stepper/graphorin/tree/main/packages/agent",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/o-stepper/graphorin.git",
    "directory": "packages/agent"
  },
  "bugs": {
    "url": "https://github.com/o-stepper/graphorin/issues"
  },
  "keywords": [
    "graphorin",
    "ai",
    "agents",
    "framework",
    "agent-runtime",
    "agent-loop",
    "streaming",
    "multi-agent",
    "handoff",
    "hitl",
    "approval",
    "fanout",
    "evaluator-optimizer",
    "fallback-chain",
    "context-compaction",
    "lateral-leak",
    "causality-monitor"
  ],
  "type": "module",
  "sideEffects": false,
  "engines": {
    "node": ">=22.12.0"
  },
  "main": "./dist/index.js",
  "module": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "default": "./dist/index.js"
    },
    "./factory": {
      "types": "./dist/factory.d.ts",
      "default": "./dist/factory.js"
    },
    "./run-state": {
      "types": "./dist/run-state/index.d.ts",
      "default": "./dist/run-state/index.js"
    },
    "./filters": {
      "types": "./dist/filters/index.d.ts",
      "default": "./dist/filters/index.js"
    },
    "./fallback": {
      "types": "./dist/fallback/index.d.ts",
      "default": "./dist/fallback/index.js"
    },
    "./preferred-model": {
      "types": "./dist/preferred-model/index.d.ts",
      "default": "./dist/preferred-model/index.js"
    },
    "./fanout": {
      "types": "./dist/fanout/index.d.ts",
      "default": "./dist/fanout/index.js"
    },
    "./evaluator-optimizer": {
      "types": "./dist/evaluator-optimizer/index.d.ts",
      "default": "./dist/evaluator-optimizer/index.js"
    },
    "./progress": {
      "types": "./dist/progress/index.d.ts",
      "default": "./dist/progress/index.js"
    },
    "./lateral-leak": {
      "types": "./dist/lateral-leak/index.d.ts",
      "default": "./dist/lateral-leak/index.js"
    },
    "./errors": {
      "types": "./dist/errors/index.d.ts",
      "default": "./dist/errors/index.js"
    },
    "./package.json": "./package.json"
  },
  "files": [
    "dist",
    "src",
    "README.md",
    "CHANGELOG.md",
    "LICENSE"
  ],
  "scripts": {
    "build": "tsdown",
    "typecheck": "tsc --noEmit && tsc -p tsconfig.tests.json",
    "test": "vitest run",
    "lint": "biome check .",
    "clean": "rimraf dist .turbo *.tsbuildinfo"
  },
  "dependencies": {
    "@graphorin/core": "workspace:*",
    "@graphorin/memory": "workspace:*",
    "@graphorin/security": "workspace:*",
    "@graphorin/skills": "workspace:*",
    "@graphorin/tools": "workspace:*"
  },
  "publishConfig": {
    "access": "public",
    "provenance": true
  },
  "devDependencies": {
    "zod": "^3.25.0"
  },
  "peerDependencies": {
    "zod": "^3.23.0 || ^4.0.0"
  },
  "peerDependenciesMeta": {
    "zod": {
      "optional": true
    }
  }
}
